import { render, staticRenderFns } from "./KanbanBoard.vue?vue&type=template&id=07bf015e&scoped=true"
import script from "./KanbanBoard.vue?vue&type=script&lang=js"
export * from "./KanbanBoard.vue?vue&type=script&lang=js"
import style0 from "./KanbanBoard.vue?vue&type=style&index=0&id=07bf015e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bf015e",
  null
  
)

export default component.exports